import { motion } from "framer-motion";
import { Apple, Check, Smartphone } from "lucide-react";
import { GOOGLE_PLAY_URL } from "@/lib/appLinks";

const bullets = [
  "Analytics dashboard with visitor origins & trends",
  "Custom seasonal stamps for events & holidays",
  "Promotions & campaigns to drive repeat visits",
  "Featured listing in the Explore feed",
];

const CAMPSITE_IMG =
  "https://images.unsplash.com/photo-1487730116645-74489c95b41b?auto=format&fit=crop&w=1400&q=80";

export default function ForOwners() {
  return (
    <section data-testid="for-owners" className="py-20 md:py-28">
      <div className="wrap grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <div className="eyebrow mb-4">For Campsite Owners</div>
          <h2 className="section-title mb-5">Grow your camping business.</h2>
          <p className="body-lg mb-8 max-w-md">
            Turn every visit into a moment your guests keep. Analytics, seasonal
            stamps, and promotions built specifically for camp operators.
          </p>
          <ul className="space-y-3 mb-8">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span
                  className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{
                    background:
                      "color-mix(in srgb, var(--brand) 15%, transparent)",
                    color: "var(--brand)",
                  }}
                >
                  <Check className="w-3.5 h-3.5" strokeWidth={3} />
                </span>
                <span className="body-lg" style={{ color: "var(--on-surface)" }}>{b}</span>
              </li>
            ))}
          </ul>
          <div className="flex flex-wrap items-center gap-3">
            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-green"
              data-testid="owners-cta"
            >
              <Smartphone className="w-4 h-4" /> Get it on Google Play
            </a>
            <a
              href="https://apps.apple.com/my/app/myadventure-passport/id6803114683"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-amber"
              data-testid="owners-cta-ios"
            >
              <Apple className="w-4 h-4" /> Download on the App Store
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <img
            src={CAMPSITE_IMG}
            alt="Campsite in the forest"
            className="w-full h-[300px] md:h-[420px] object-cover rounded-[20px] shadow-2xl"
          />
          <div className="absolute -bottom-6 -left-6 hidden md:block card-elev p-5">
            <div className="flex items-center gap-3">
              <div className="hex-stamp w-12 h-12 bg-[#FCD34D] flex items-center justify-center text-[#1F4A2E] font-extrabold text-xs">
                +100
              </div>
              <div>
                <div className="text-xs font-bold" style={{ color: "var(--on-surface-muted)" }}>
                  Fresh stamp
                </div>
                <div className="text-sm font-extrabold" style={{ color: "var(--on-surface)" }}>
                  Cameron Highlands
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
